import { render, staticRenderFns } from "./body-settings.vue?vue&type=template&id=a1f7709a"
import script from "./body-settings.vue?vue&type=script&lang=js"
export * from "./body-settings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports